import { Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react';
// import useLayoutContext from "src/hooks/useAuthLayout";


// const { drawerOpen } = useLayoutContext()

export default function ExamenesEspeciales({ handleChangedTextState, text, mostrarCheck2 }) {


    // const [campos] = useState([
    //     {
    //         id: 'informacionClinica',
    //         label: "Información clínica",
    //         value: ""
    //     },
    //     {
    //         id: 'impresionDiagnostica',
    //         label: "Impresión diagnóstica",
    //         value: ""
    //     },
    //     {
    //         id: 'examenSolicitado',
    //         label: "Examen Solicitado",
    //         value: ""
    //     },
    //     {
    //         id: 'codigo',
    //         label: "Código",
    //         value: ""
    //     },
    // ])


    // const handleChangeDescripcion = (id, valor, key) => {
    //     setDescrip(x => x.reduce((arr, item) => {
    //       arr.push({
    //         ...item, [key]: item.id === id ? valor : item[key]
    //       })
    //       return arr
    //     }, []))
    //   }

    // const handleChangeData = (id, valor) => {
    //     setCampos(x => x.reduce((arr, item) => {
    //         if (item.id === id) {
    //             arr.push({
    //                 ...item, value: valor
    //             })
    //         } else {
    //             arr.push(item)
    //         }
    //         return arr
    //     }, []))
    // }

    // useEffect(() => {
    //     console.log(campos)
    //     // console.log(drawerOpen)
    // }, [campos])

    return (
        <>
            <Grid container spacing={1} sx={{ my: 1, pb: 3, px: 2, mt: 2 }} >
                <Grid item lg={12} sx={{ mx: 0 }}>
                    <Typography variant="h3" sx={{ mb: 1 }}><b>EXÁMENES ESPECIALES</b></Typography>
                </Grid>
                        <>
                            <Grid  lg={12}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Información Clínica</b></Typography>
                                <TextField
                                    fullWidth
                                    label={''}
                                    multiline
                                    rows={3}
                                    type={"text"}
                                    variant="outlined"
                                    // onChange={(e) => handleChangeData(item.id, e.target.value)}
                                    onChange={(e) => handleChangedTextState(e.target.value, 'infEspeciales')}
                                    value={text.find(x => x.id === 'infEspeciales').text}
                                />
                            </Grid>
                        </>
                    
                        <>
                            <Grid style={{ marginTop: "20px" }} lg={12}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Información Diagnóstica</b></Typography>
                                <TextField
                                    fullWidth
                                    label={''}
                                    multiline
                                    rows={3}
                                    type={"text"}
                                    variant="outlined"
                                    // onChange={(e) => handleChangeData(item.id, e.target.value)}
                                    onChange={(e) => handleChangedTextState(e.target.value, 'impEspeciales')}
                                    value={text.find(x => x.id === 'impEspeciales').text}
                                />
                            </Grid>
                        </>
                    
                        <>
                            <Grid style={{ marginTop: "20px" }} lg={5}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Información Diagnóstica</b></Typography>
                                <TextField
                                    fullWidth
                                    label={''}
                                    
                                    rows={1}
                                    type={"text"}
                                    variant="outlined"
                                    // onChange={(e) => handleChangeData(item.id, e.target.value)}
                                    onChange={(e) => handleChangedTextState(e.target.value, 'infExamenEspeciales')}
                                    value={text.find(x => x.id === 'infExamenEspeciales').text}
                                />
                            </Grid>
                        </>
                    
                        <>
                            <Grid style={{ marginTop: "20px", marginLeft: "25px" }} lg={5}>
                                <Typography variant="h5" sx={{ mb: 1 }}><b>Información Diagnóstica</b></Typography>
                                <TextField
                                    fullWidth
                                    label={''}
                                    
                                    rows={1}
                                    type={"number"}
                                    variant="outlined"
                                    // onChange={(e) => handleChangeData(item.id, e.target.value)}
                                    onChange={(e) => handleChangedTextState(e.target.value, 'impExamenEspeciales')}
                                    value={text.find(x => x.id === 'impExamenEspeciales').text}
                                />
                            </Grid>
                        </>
                    
                

            </Grid>
            <Grid container spacing={1} sx={{ my: 1, pb: 3, px: 2, mt: 2 }} >
                <Grid item lg={12} sx={{ mx: 2 }}>
                    <Button fullWidth variant='contained' sx={{ p: 2 }}
                        onClick={mostrarCheck2}> Grabar </Button>
                </Grid>
            </Grid>
        </>
    )
}


